
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-trees/[slug]",
      function () {
        return require("private-next-pages/native-trees/[slug]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-trees/[slug]"])
      });
    }
  